import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

class StaffFulfilmentShow extends Component {
  render() {
    const location_id = this.props.match.params.location_id
    const rota_id = this.props.match.params.rota_id

    if (rota_id !== undefined) {
      return <Redirect to={`/staff-fulfilment/${location_id}/rotas/${rota_id}/weekly/shifts`}/>
    }
    else {
      return <Redirect to={`/staff-fulfilment/${location_id}/weekly/shifts`}/>
    }
  }
}

export default StaffFulfilmentShow;
